import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _throttle from "lodash/throttle";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import pipelineStatusValues from 'utils/pipelineStatusValues';
import { getBackendStatus, getHasSampleTech } from 'redux/selectors';
import SampleTech from 'const/enums/SampleTech';
import fetchAPI from 'utils/http/fetchAPI';
var WORKER_KEEPALIVE_THROTTLE_MS = 60000;
var INTERACTION_EVENTS = ['mousedown', 'keydown', 'scroll', 'touchstart'];
var sendWorkerKeepalive = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(experimentId) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return fetchAPI("/v2/experiments/".concat(experimentId, "/worker/activate"), {
            method: 'POST'
          });
        case 3:
          _context.next = 8;
          break;
        case 5:
          _context.prev = 5;
          _context.t0 = _context["catch"](0);
          console.debug('[worker activate] ignored:', _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message);
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 5]]);
  }));
  return function sendWorkerKeepalive(_x) {
    return _ref.apply(this, arguments);
  };
}();
var useWorkerKeepalive = function useWorkerKeepalive(experimentId) {
  var isProcessed = useSelector(function (state) {
    var _getBackendStatus, _status$pipeline, _status$seurat, _status$gem2s;
    var status = (_getBackendStatus = getBackendStatus(experimentId)(state)) === null || _getBackendStatus === void 0 ? void 0 : _getBackendStatus.status;
    if (!status) return false;

    // Anndata shares the gem2s pipeline_type bucket and never launches QC
    // (status.pipeline), so its completion only ever shows up on status.gem2s.
    var _getHasSampleTech = getHasSampleTech(experimentId, [SampleTech.ANNDATA])(state),
      hasAnndataTechnology = _getHasSampleTech.perTech[SampleTech.ANNDATA];
    return ((_status$pipeline = status.pipeline) === null || _status$pipeline === void 0 ? void 0 : _status$pipeline.status) === pipelineStatusValues.SUCCEEDED || ((_status$seurat = status.seurat) === null || _status$seurat === void 0 ? void 0 : _status$seurat.status) === pipelineStatusValues.SUCCEEDED || hasAnndataTechnology && ((_status$gem2s = status.gem2s) === null || _status$gem2s === void 0 ? void 0 : _status$gem2s.status) === pipelineStatusValues.SUCCEEDED;
  });
  useEffect(function () {
    if (!experimentId || !isProcessed) return undefined;
    var throttledActivate = _throttle(function () {
      return sendWorkerKeepalive(experimentId);
    }, WORKER_KEEPALIVE_THROTTLE_MS, {
      leading: true,
      trailing: false
    });
    throttledActivate();
    INTERACTION_EVENTS.forEach(function (event) {
      document.addEventListener(event, throttledActivate, {
        passive: true
      });
    });
    return function () {
      INTERACTION_EVENTS.forEach(function (event) {
        document.removeEventListener(event, throttledActivate, {
          passive: true
        });
      });
      throttledActivate.cancel();
    };
  }, [experimentId, isProcessed]);
};
export default useWorkerKeepalive;